// 计算实际支付金额
export const getActualPayAmount = (voucher = null, stake = 0) => {
  if (!voucher) return stake
  const result = voucher ? stake - voucher.amountLong : stake
  return result > 0 ? result : 0
}
